export default __webpack_public_path__ + "static/media/purple-candy.5dc3c5e6.png";